import { Chip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface IProps {
  sx?: SxProps<Theme>;
}

/* Marks an inactive customer: in the search box's results, the Contact dialog, and the Customers tab's list. */
export default function InactiveChip({ sx }: IProps) {
  return <Chip size="small" variant="soft" color="error" label="Inactive" sx={sx} />;
}
